import React from 'react';
import { FolderIcon, PhoneIcon, UnfollowIcon, BlockIcon, CommentsIcon } from 'tt-ui-lib/icons';
import styles from '../MessageList.module.scss';

const actions = [
  {
    name: 'Add to folder',
    type: 'add_to_folder',
    icon: <FolderIcon style={{ width: 18, height: 15 }} />,
    iconWidth: 17,
    iconHeight: 13,
  },
  {
    name: 'Call',
    type: 'call',
    icon: <PhoneIcon style={{ width: 16, height: 16 }} />,
    iconWidth: 16,
    iconHeight: 16,
  },
  {
    name: 'Unfollow',
    type: 'unfollow',
    icon: <UnfollowIcon className={styles.unfollowIcon} style={{ width: 18, height: 18 }} />,
    iconWidth: 18,
    iconHeight: 18,
  },
  {
    name: 'Block',
    type: 'block',
    icon: <BlockIcon style={{ width: 18, height: 18 }} />,
    iconWidth: 18,
    iconHeight: 18,
  },
  {
    name: 'Report',
    type: 'report',
    icon: <CommentsIcon style={{ width: 17, height: 17 }} />,
    iconWidth: 15,
    iconHeight: 22,
  },
];

const ActionsDropdown = ({ onActionClick }) => (
  <>
    {actions.map((action) => (
      <div
        key={action.type}
        className={styles.dropdownItem}
        onClick={() => onActionClick(action.type)}
      >
        <div className={styles.dropdownItemIcon}>{action.icon}</div>
        <div className={styles.dropdownItemText}>{action.name}</div>
      </div>
    ))}
  </>
);

export default ActionsDropdown;
